module.exports = "/_next/static/resources/pack-a7796a7433e4714f331477bd957244da.jpg";